import React, { useState, useRef, useEffect } from 'react'
import {
  axios,
  apiUrl,
  Link,
  connect,
  mapStateToProps,
  mapDispatchToProps,
  SpinnerButton,
  cookies,
  Redirect,
  logoDark,
  pushDataLayer,
  useQuery,
  getLangPublicPage,
  handleDarkModePublicPage,
  logoLight
} from '../../helpers/Common'
import logoGoogle from '../../assets/images/login/logos_google-icon.png'
import { Carousel } from 'react-bootstrap'
import dataCarousel from './carousel'
import { LangAuthEmail, LangAuthPassword, LangCompanyLogin, LangDontHaveCompanyAccount, LangForgotYourPassword, LangLogIn, LangOr, LangPleaseCheckEmailAgain, LangPleaseLogin, LangRegistrationVerificationSuccessful, LangSignUpNow, LangSigninWithGoogle } from '../../constant/AuthConstant'

const LoginComponent = (props) => {
  const query = useQuery()

  const [state, setState] = useState({
    onSubmit: false,
    invalidCredential: false,
    invalidCredentialMsg: '',
    loginSuccess: false,
    errors: {},
    errorMessage: '',
    email: '',
    password: '',
    errorGoogleSignIn: query.get('error') ?? '',
    lang: getLangPublicPage().value,
    langFromQuery: getLangPublicPage().origin === 'query',
    isEmailVerificationSuccess: query.get('email') && query.get('verified') === '1' ? true : false
  })
  const { errorMessage, errorGoogleSignIn, email, password, onSubmit, errors, invalidCredential, invalidCredentialMsg, loginSuccess } = state

  const refEmail = useRef()

  useEffect(() => {
    /**
     * cek cookies, sudah ada belum
     */
    const token = cookies.get('token')
    if (token) {
      setState({ ...state, loginSuccess: true })
    }

    refEmail.current.focus()
    handleDarkModePublicPage(cookies.get('mode'))
    // eslint-disable-next-line
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setState({ ...state, onSubmit: true, invalidCredential: false, errorGoogleSignIn: '' })

    await axios.post(apiUrl + '/auth', {
      email: email,
      password: password,
      lang_interface: state.lang.toLowerCase()
    }).then((result) => {
      if (result.data.access_token) {
        if (result.data.personnel_id !== null && (!result.data.supervisor_groups || result.data.supervisor_groups.length <= 0) && !result.data.attr.sales_manager) {
          setState({ ...state, onSubmit: false, invalidCredential: true, invalidCredentialMsg: 'Anda berstatus sebagai Karyawan, silakan login pada aplikasi mobile Kerjoo.', errors: '', errorMessage: '', errorGoogleSignIn: '' })
        } else {
          /**
           * push data layer
           */
          pushDataLayer({
            event: 'login_success',
            websiteId: result.data.website_id,
            userId: result.data.id,
            name: result.data.name,
            email: result.data.email
          })

          /**
           * set cookies
           */
          cookies.set('token', result.data.access_token)
          setState({ ...state, loginSuccess: true, errors: '', errorMessage: '', errorGoogleSignIn: '' })
        }
      } else {
        setState({ ...state, onSubmit: false, invalidCredential: true, invalidCredentialMsg: result.data.message || '', errors: '', errorMessage: '', errorGoogleSignIn: '' })
      }
    }).catch((error) => {
      setState({ ...state, onSubmit: false, invalidCredential: false, errors: error.response.data.errors, errorMessage: error.response.data.message, errorGoogleSignIn: '' })
    })
  }

  if (loginSuccess) {
    return <Redirect to='/dashboard' />
  }

  return (
    <div className='container-fluid p-0 public-page'>
      <div className='row bg-white no-gutters'>
        <div className='col col-lg-6 pt-0 pt-md-3 pt-lg-5 mx-auto h-100 bg-white d-flex flex-column justify-content-start align-items-center' style={{ minHeight: '100vh' }}>
          <div className='card mx-auto mt-2 shadow-none px-3 px-md-5' style={{ maxWidth: '513px' }}>
            <div className='card-header px-1 pb-0 pt-3 border-0'>
              <img className='for-dark' width={146} src={logoLight} alt='Kerjoo-Logo-Light' />
              <img className='for-light' width={146} src={logoDark} alt='Kerjoo-Logo-Dark' />
              {state.isEmailVerificationSuccess && (
                <div className='alert alert-success mt-4'>
                  <span className='font-weight-bold' style={{ fontSize: '1rem' }}>{LangRegistrationVerificationSuccessful(state.lang)}</span>
                  <p className='mt-2' style={{ lineHeight: '17px' }}>{LangPleaseCheckEmailAgain(state.lang, query.get('email'))}</p>
                </div>
              )}
              <h4 className={state.isEmailVerificationSuccess ? 'mt-3 mt-lg-4' : 'mt-5 mt-lg-4'}>{LangCompanyLogin(state.lang)}</h4>
              <p className='mt-3 mb-0' style={{ lineHeight: '17px' }}>{LangPleaseLogin(state.lang)}</p>
            </div>
            <form onSubmit={handleSubmit} autoComplete='off'>
              <div className='card-body pt-5 pt-lg-4 px-1 pb-0'>
                <div className='form-group mb-3'>
                  <input style={{ height: '48px', fontSize: '14px' }} placeholder={LangAuthEmail(state.lang)} ref={refEmail} className={'form-control p-3' + ((errors.email) ? ' is-invalid' : '')} value={email} type='email' onChange={(e) => setState({ ...state, email: e.target.value })} />
                  {(errors.email) ? <div className='invalid-feedback'><strong>{errors.email}</strong></div> : null}
                </div>
                <div className='form-group'>
                  <input style={{ height: '48px', fontSize: '14px' }} placeholder={LangAuthPassword(state.lang)} autoComplete='new-password' className={'form-control p-3' + ((errors.password) ? ' is-invalid' : '')} value={password} type='password' onChange={(e) => setState({ ...state, password: e.target.value })} />
                  {(errors.password) ? <div className='invalid-feedback'><strong>{errors.password}</strong></div> : null}
                  <br />
                  <Link to={state.langFromQuery ? `/password/forgot?lang=${state.lang}` : '/password/forgot'}>{LangForgotYourPassword(state.lang)}</Link>
                </div>

                {invalidCredential || errorGoogleSignIn || errorMessage
                  ? (
                    <div className='alert alert-warning text-secondary'>
                      {invalidCredentialMsg || errorGoogleSignIn || errorMessage}
                    </div>
                  )
                  : null}

                <div className='mt-4'>
                  <button style={{ background: '#25A091', height: '48px' }} type='submit' disabled={onSubmit} className='btn btn-block p-2 text-light'>{(onSubmit) ? SpinnerButton : ''} {LangLogIn(state.lang)}</button>
                  <div className='position-relative my-4'>
                    <hr />
                    <p className='text-center position-absolute w-100' style={{ bottom: -10 }}><span className='bg-white px-2 text-secondary'>{LangOr(state.lang)}</span></p>
                  </div>
                  <a href={process.env.REACT_APP_GOOGLE_SIGN_IN} style={{ border: '1px solid #25A091', color: '#25A091', height: '48px' }} className='btn btn-block p-2 align-top d-flex justify-content-center align-items-center'>
                    <img className='mx-2' src={logoGoogle} alt='google' />
                    <span>{LangSigninWithGoogle(state.lang)}</span>
                  </a>
                  <p className='mt-4 text-center'>{LangDontHaveCompanyAccount(state.lang)} <Link to={state.langFromQuery ? `/register?lang=${state.lang}` : '/register'}>{LangSignUpNow(state.lang)}</Link></p>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className='col-6 pb-4 mx-auto h-100 d-none d-lg-flex flex-column justify-content-start align-items-center bg-green' style={{ minHeight: '100vh', paddingTop: '98px' }}>
          <Carousel controls={false}>
            {dataCarousel.map((dc, i) => (
              <Carousel.Item key={i} interval={5000}>
                <Carousel.Caption className='carousel-caption d-block position-static text-dark text-left' style={{ top: '50%', height: '520px' }}>
                  <div className='d-flex flex-column align-items-center'>
                    <img height={300} src={dc.illus} alt='illustration' />
                    <div style={{ width: '428px' }}>
                      <h5 className='mt-4 mb-0 font-weight-bold text-center text-white'>{dc.title[state.lang] ?? dc.title['ID']}</h5>
                      <p className='mt-3 text-center text-white' style={{ lineHeight: '17px' }}>{dc.desc[state.lang] ?? dc.desc['ID']}</p>
                    </div>
                  </div>
                </Carousel.Caption>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginComponent)
